// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"318fac01","378":"2331cbc1","781":"9be23f1c","787":"3540f220","904":"26410d0b"}[chunkId] + ".chunk.js";
};